import React, { Component, Fragment } from "react";
import "./Retro.css"
import Slotsanimation from "../Slotanimation/SlotsAnimation"
import WinningAmount from "../Animations/winningAmt/winningamt"
import WinLines from "../Animations/DrawLine_Win_Animation/WinLines";
import WinPulse from "../Animations/WinningPulseAn/WinPulse"
import WinBGColor from "../Animations/WinBGColor/WinBGClr"
import FreeSpins from "../Animations/freespins/FreeSpins"

import chip_10 from "../../../../../assets/games/russianPoker/black.png";
import chip_25 from "../../../../../assets/games/russianPoker/Purple chip.svg";
import chip_50 from "../../../../../assets/games/russianPoker/blue.png";
import chip_100 from "../../../../../assets/games/russianPoker/red.png";
import chip_500 from "../../../../../assets/games/russianPoker/yellow.png";
import chip_1000 from "../../../../../assets/games/russianPoker/Whitechip.svg"
import betincerementdecrement from "../../../../../assets/games/slots/Retrotech/inceaseArrow.png";
import circlechip from "../../../../../assets/games/slots/Retrotech/chipCircle.png";
import spinbtn from "../../../../../assets/games/slots/Retrotech/spinbtn.png";

import freespins from "../../../../../assets/games/slots/Retrotech/freespin.png"
import clear from "../../../../../assets/games/slots/Retrotech/clear.png"
import bet from "../../../../../assets/games/slots/Retrotech/bet.png"
import logo from "../../../../../assets/games/slots/Retrotech/logo.png"
import autoplay from "../../../../../assets/games/slots/Retrotech/autoplay.png"
import border from "../../../../../assets/games/slots/Retrotech/Border.png"
import win from "../../../../../assets/games/slots/Retrotech/win.png"
import balance from "../../../../../assets/games/slots/Retrotech/balance.png"
import closeBtn from "../../../../../assets/games/slots/Retrotech/Asset 26.png"

// import img12 from '../../../../../assets/games/slots/Retrotech/logo.png';
import menu from '../../../../../assets/games/slots/Retrotech/menu.png';
import linescountimg from '../../../../../assets/games/slots/Retrotech/linesCount.png';
import Chips from "../../../../../library/Chips/Chips";

// ICON imports...
import img1 from '../../../../../assets/games/slots/Retrotech/Asset 2.png';
import img2 from '../../../../../assets/games/slots/Retrotech/Asset 3.png';
import img3 from '../../../../../assets/games/slots/Retrotech/Asset 4.png';
import img4 from '../../../../../assets/games/slots/Retrotech/Asset 5.png';
import img5 from '../../../../../assets/games/slots/Retrotech/Asset 6.png';
import img6 from '../../../../../assets/games/slots/Retrotech/Asset 7.png';
import img7 from '../../../../../assets/games/slots/Retrotech/Asset 8.png';
import img8 from '../../../../../assets/games/slots/Retrotech/Asset 9.png';
import img9 from '../../../../../assets/games/slots/Retrotech/Asset 10.png';
import img10 from '../../../../../assets/games/slots/Retrotech/Asset 11.png';
import img11 from '../../../../../assets/games/slots/Retrotech/Asset 12.png';
import img12 from '../../../../../assets/games/slots/Retrotech/Asset 13.png';
import img13 from '../../../../../assets/games/slots/Retrotech/Asset 14.png';

import img14 from '../../../../../assets/games/slots/Retrotech/Asset 15.png';
import img15 from '../../../../../assets/games/slots/Retrotech/Asset 16.png';

class RetroTech extends Component {
  payoutlist = [
    { linesCount: 1, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 1, 1, 1, 1], clr: "#fa7705" }, // 1
    { linesCount: 2, backGroung_G_clr: ['#687ced', '#9c0983'], active: true, payoutLine: [0, 0, 0, 0, 0], clr: "#05fa36" }, // 2
    { linesCount: 3, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 2, 2, 2, 2], clr: "#fa7705" }, // 3
    { linesCount: 4, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [0, 1, 2, 1, 0], clr: "#ffff" }, // 4
    { linesCount: 5, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 1, 0, 1, 2], clr: "#0c28b3" }, // 5
    { linesCount: 6, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 0, 1, 2, 1], clr: "salmon" }, // 6
    { linesCount: 7, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 2, 1, 0, 1], clr: "skyblue" }, // 7
    { linesCount: 8, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [0, 1, 0, 1, 0], clr: "red" }, // 8
    { linesCount: 9, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 1, 2, 1, 2], clr: "firebrick" }, // 9
    { linesCount: 10, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 0, 0, 0, 1], clr: "limegreen" }, // 10
    { linesCount: 11, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 2, 2, 2, 1], clr: "darkgreen" }, // 11
    { linesCount: 12, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 0, 2, 0, 1], clr: "indianred" }, // 12
    { linesCount: 13, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 2, 0, 2, 1], clr: "navy" }, // 13
    { linesCount: 14, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 2, 1, 0, 0], clr: "darkseagreen" }, // 14
    { linesCount: 15, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [0, 0, 1, 2, 2], clr: "crimson" }, // 15
    { linesCount: 16, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 1, 1, 1, 2], clr: "deepskyblue" }, // 16
    { linesCount: 17, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [0, 1, 1, 1, 0], clr: "rosybrown" }, // 17
    { linesCount: 18, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [0, 2, 0, 2, 0], clr: "yellow" }, // 18
    { linesCount: 19, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 0, 2, 0, 2], clr: "lightgreen" }, // 19
    { linesCount: 20, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 1, 0, 1, 1], clr: "hotpink" }, // 20
    { linesCount: 21, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 1, 2, 1, 1], clr: "mediumpurple" }, // 21
    { linesCount: 22, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 2, 0, 2, 2], clr: "mediumblue" }, // 22
    { linesCount: 23, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [0, 0, 2, 0, 0], clr: "darkviolet" }, // 23
    { linesCount: 24, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 2, 1, 0, 1], clr: "orangered" }, // 24
    { linesCount: 25, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [0, 0, 1, 2, 1], clr: "forestgreen" }, // 25
  ]
  constructor(props) {

    // alert("REtro")
    super(props);
    this.state = {
      betchipincrementbtn: false,
      count: 1,
      betdecreamentbtn: false,
      anteamount: 1,
      chipcount: 1,
      TotalBalance: this.props.balance,
      winAMT: 0,
      gamewins: false,
      linescount: 25,
      showAutoPlayOptions: false,
      autoPlayOptions: [3, 25, 50, 100],
      autoPlayCount: 0,
      isAutoPlay: false,
      showCancelAutoPlay: false,
      prevAutoCount: 0,
      PayoutTableShow: false,
      drawnLinesT: false,
      drawnLinesresDate: [],
      isSpinning: false,
      UpdatedPayoutList: [],

      menuActive: false,
      ErrorPopup: false,
      WinPulseRT: false,
      WinBGColorsRT: false,
      IndexWinningIcons: [0, , 1, 2, 3, 4],
      isFreeSpins: false,
      FreeSpinsCount: 0,
      TotalFreeSpinsCount: 0,
      BetResponse: [],
      freeSpinsPopup: false,

    }
    this.updatePlayerInfo = this.updatePlayerInfo.bind(this);
    this.setWinsAndAmount = this.setWinsAndAmount.bind(this);
    this.getGameState = this.getGameState.bind(this);
    this.chipVal = [
      { src: chip_10, key: 1, label: "10", val: 10 },
      { src: chip_25, key: 2, label: "20", val: 20 },
      { src: chip_50, key: 3, label: "50", val: 50 },
      { src: chip_100, key: 4, label: "100", val: 100 },
      { src: chip_500, key: 5, label: "500", val: 500 },
      { src: chip_1000, key: 6, label: "1000", val: 1000 },
    ];

    this.Slotsanimation = React.createRef();
    this.paylines = [
      { id: 1, positions: [1, 1, 1, 1, 1] },      // Middle row
      { id: 2, positions: [0, 0, 0, 0, 0] },      // Top row
      { id: 3, positions: [2, 2, 2, 2, 2] },      // Bottom row
      { id: 4, positions: [0, 1, 2, 1, 0] },      // V shape
      { id: 5, positions: [2, 1, 0, 1, 2] },      // Inverted V
      { id: 6, positions: [0, 1, 0, 1, 0] },      // Zigzag
      { id: 7, positions: [2, 1, 2, 1, 2] },      // Zigzag reverse
      { id: 8, positions: [0, 0, 1, 0, 0] },      // small peak
      { id: 9, positions: [2, 2, 1, 2, 2] },      // small valley
      { id: 10, positions: [0, 1, 1, 1, 0] },
      { id: 11, positions: [2, 1, 1, 1, 2] },
      { id: 12, positions: [1, 0, 0, 0, 1] },
      { id: 13, positions: [1, 2, 2, 2, 1] },
      { id: 14, positions: [0, 0, 2, 0, 0] },
      { id: 15, positions: [2, 2, 0, 2, 2] },
      { id: 16, positions: [0, 2, 0, 2, 0] },
      { id: 17, positions: [2, 0, 2, 0, 2] },
      { id: 18, positions: [0, 1, 2, 1, 0] },
      { id: 19, positions: [2, 1, 0, 1, 2] },
      { id: 20, positions: [1, 0, 2, 0, 1] },
      { id: 21, positions: [1, 2, 0, 2, 1] },
      { id: 22, positions: [0, 2, 2, 2, 0] },
      { id: 23, positions: [2, 0, 0, 0, 2] },
      { id: 24, positions: [0, 1, 1, 1, 0] },
      { id: 25, positions: [2, 1, 1, 1, 2] },
    ];
    this.cellSize = 40;
    this.rows = 3;
    this.cols = 5;
    this.activeColor = "#0db9ccff"; // 🔹 Aqua-blue
    this.inactiveColor = "#070707b4"; // 🔹 Dark
    this.lineColor = "#e6c408ff"; // line inside selected

    this.Game_Icons = {
      img1, img2, img3, img4, img5, img6,
      img7, img8, img9, img10, img11, img12, img13, img14, img15
    };
    this.Game_Icons_dummy = {
      img1, img2, img3, img4, img5, img6,
      img7, img8, img9, img10, img11, img12
    };
  }
  componentDidMount() {
    this.Slotsanimation.current.GameImgs(this.Game_Icons, this.Game_Icons_dummy)
    this.handleImageLoad()

    const { childRef } = this.props;
    childRef(this);
    this.setState({
      UpdatedPayoutList: this.payoutlist
    })
    console.log(this.props.balance)
    console.log(this.props.balance)
    this.setState({
      TotalBalance: this.props.balance,
      anteamount: Number(this.props.os_chipValues.split(",")[0]) * Number(this.state.linescount)
    })
    // let increamentchip = document.getElementById("betincrenetTP")
    // let decreamentchip = document.getElementById("betdecrementTP")

    // increamentchip.src = betincerementdecrement
    // decreamentchip.src = betincerementdecrement
    console.log(this.chipVal, this.props.os_chipValues)
    this.chipVal = this.props.os_chipValues.split(",").map((ele, ind) => ({ val: ele, chipindex: ind + 1 }));
  }

  updatePlayerInfo() {
    console.log("enter")
    console.log(this.props.balance)
    this.setState({
      TotalBalance: this.props.balance
    })
  }

  updateGameState(res) {
    console.log(res, this.state.autoPlayCount)
    if (res.handId !== res.oldHandId && this.state.autoPlayCount && this.state.isAutoPlay) {
      // this.Slotsanimation.current.autoPlayStart()
      this.spinaction()
    } else if (this.state.isAutoPlay && !this.state.autoPlayCount) {
      this.setState({ isAutoPlay: false })
    } else {
      this.stopAutoPlay()
    }
  }

  spinaction = (body) => {

    if (this.state.TotalBalance > this.state.anteamount) {
      console.log(body)
      this.setState({
        drawnLinesT: false,
        WinPulseRT: false,
        WinBGColorsRT: false,
        drawnLinesresDate: []
      })
      let SlotsBody = {
        sessionId: sessionStorage.getItem("sessionId"),
        CN: "RETRO_TECH_BET",
        object: {
          action: "PARAM_BET",
          gameId: this.props.gameId,
          playerId: Number(this.props.playerId),
          handId: Number(this.props.gameState.handId),
          linesCount: this.state.linescount,
          coin: Number(this.state.chipcount),
          coinCount: Number(this.state.chipcount),
        }
      }
      this.setState({
        TotalBalance: this.props.balance
      })
      console.log(this.state.TotalBalance)
      console.log(this.state.anteamount)
      this.setState({
        TotalBalance: Number(Number(this.state.TotalBalance) - Number(this.state.anteamount)).toFixed(2)
      })
      console.log(this.state.TotalBalance)

      console.log(SlotsBody)
      this.props.network.sendof(SlotsBody);
    } else {
      alert("You don't have Balance")
      this.setState({
        ErrorPopup: true
      })
    }
  }

  getGameState() {
    alert("Game State")
    const body = {
      sessionId: sessionStorage.getItem("sessionId"),
      CN: "GET_GAME_STATE",
      object: {
        gameId: this.props.gameId,
        playerId: Number(this.props.playerId),
      },
    };
    this.props.network.sendof(body);
  }

  IncreamentBetchips = () => {

    if (this.state.count < this.chipVal.length) {
      this.setState(
        (prevState) => ({
          count: prevState.count + 1,
        }),
        () => {
          console.log(this.chipVal[this.state.count - 1].val)
          this.setState({
            anteamount: Number(this.chipVal[this.state.count - 1].val) * Number(this.state.linescount),
            chipcount: this.chipVal[this.state.count - 1].chipindex
          })
          if (this.state.count > 6) {
            this.setState({ betchipincrementbtn: true, betdecreamentbtn: false });

          }
          else {
            this.setState({ betchipincrementbtn: false });
          }
          // this.betChipsIncrementDecremenAction()
          console.log(this.state.anteamount)
        })
    }
    console.log(this.state.count)

  };

  DecreamentBetchips = () => {
    if (this.state.count > 1) {
      this.setState(
        (prevState) => ({
          count: prevState.count - 1,
        }),
        () => {
          console.log(this.chipVal[this.state.count - 1].val)
          this.setState({
            anteamount: Number(this.chipVal[this.state.count - 1].val) * Number(this.state.linescount),
            chipcount: this.chipVal[this.state.count - 1].chipindex
          })

          if (this.state.count < 1) {
            this.setState({ betdecreamentbtn: true, betchipincrementbtn: false });
          } else {
            this.setState({ betdecreamentbtn: false });
          }
          //   this.betChipsIncrementDecremenAction();
        }
      );
    }
    console.log(this.state.count)
  };

  RetroBetRes = (res) => {
    console.log(res)
    this.setState({
      BetResponse: res
    })
    this.Slotsanimation.current.spinofcheck(res.reels, res.winningreels, res.winAmount)

    if (res.freeSpinsCount > 0) {
      if (res.playedFreeSpinsCount < res.freeSpinsCount) {
        this.freeSpinActive(res)
      }
    }
  }

  Increamentlinescount = () => {
    this.setState(
      (prevState) => ({
        linescount: Math.min(prevState.linescount + 1, 25),
        anteamount: Number(this.chipVal[this.state.count - 1].val) * Math.min(prevState.linescount + 1, 25),
      }),
      () => {
        this.setNewActiveLines('INC')
      }
    );
  };

  Decreamentlinescount = () => {
    this.setState(
      (prevState) => ({
        linescount: Math.max(prevState.linescount - 1, 1),
        anteamount: Number(this.chipVal[this.state.count - 1].val) * Math.max(prevState.linescount - 1, 1),
      }),
      () => {
        this.setNewActiveLines('DEC')
      }
    );
  };

  setWinsAndAmount(winAmount) {
    this.setState({
      gamewins: Boolean(winAmount),
      winAMT: winAmount,
      freeSpinsPopup: Boolean(winAmount)
    })

    if (!winAmount) {
      this.setState((prevState) => ({
        ...prevState,
        autoPlayCount: prevState.autoPlayCount > 0 ? prevState.autoPlayCount - 1 : 0,
      }), () => {
        this.updateplayerbalnace()
        this.getGameState()
      })

      // if (this.state.isFreeSpins) {
      //   if (this.state.FreeSpinsCount > 0 && this.state.TotalFreeSpinsCount > 0) {
      //     this.freeASpinsStart()
      //     this.setState((prevState) => ({
      //       ...prevState,
      //       autoPlayCount: prevState.autoPlayCount > 0 ? prevState.autoPlayCount - 1 : 0,
      //     }), () => {
      //       this.updateplayerbalnace()
      //       this.getGameState()
      //     })
      //   }
      // }
    }
  }

  handleAutoPlayClick = () => {
    const { autoPlayCount, isAutoPlay } = this.state;

    if (!autoPlayCount) {
      // Case 1: No count yet → open options
      this.setState({ showAutoPlayOptions: true });
    } else if (isAutoPlay) {
      // Case 2: Already auto playing → stop

      this.setState((prevState) => ({ ...prevState, autoPlayCount: 0, isAutoPlay: true, showCancelAutoPlay: true, prevAutoCount: prevState.autoPlayCount }));
      // this.setState({ autoPlayCount: 0, isAutoPlay: false });
    } else {
      // Case 3: Not playing → start
      this.setState({ isAutoPlay: true, showAutoPlayOptions: false, showCancelAutoPlay: false }, () => {
        // this.Slotsanimation.current.autoPlayStart();
        this.spinaction()

      });
    }
  };

  stopAutoPlay = () => {
    this.setState({ autoPlayCount: 0, isAutoPlay: false, showCancelAutoPlay: false });
  }

  restartAutoPlay = () => {
    this.setState((prevState) => ({ ...prevState, autoPlayCount: prevState.prevAutoCount - 1, showCancelAutoPlay: false, isAutoPlay: false }), () => {
      this.handleAutoPlayClick()
    })
  }
  OpenPayoutTable = () => {
    this.setState({
      PayoutTableShow: true
    })
  }
  ClosePayoutTable = () => {
    this.setState({
      PayoutTableShow: false
    })
  }
  createLine = (ctx, fromX, fromY, toX, toY, clr) => {
    ctx.beginPath();
    ctx.moveTo(fromX, fromY);
    ctx.lineTo(toX, toY);
    ctx.strokeStyle = clr;
    ctx.lineWidth = 8;
    ctx.shadowColor = clr;
    ctx.shadowBlur = 20;

    ctx.stroke();

    // reset shadow so it doesn’t affect other drawings
    ctx.shadowColor = "transparent";
    ctx.shadowBlur = 0;
  }
  CreateRetroLines = (data) => {
    let ctx = data.ctx
    let canvas = data.canvas
    this.createLine(ctx, canvas.width / 5, 0, canvas.width / 5, canvas.height, "#ff00cf")
    this.createLine(ctx, canvas.width * 2 / 5, 0, canvas.width * 2 / 5, canvas.height, "#ff00cf")
    this.createLine(ctx, canvas.width * 3 / 5, 0, canvas.width * 3 / 5, canvas.height, "#14edef")
    this.createLine(ctx, canvas.width * 4 / 5, 0, canvas.width * 4 / 5, canvas.height, "#14edef")
  }
  CreateWinAnimationsData = (data) => {
    // console.log(data)
    this.setState({
      drawnLinesT: true,   // Enable draw lines
      WinPulseRT: true,   // Enable pulse
      // WinBGColorsRT: true,   // Enable BGColor && Pulse
      drawnLinesresDate: data
    })

  }

  SpinControlDis = (resData) => {
    this.setState({
      isSpinning: resData
    })
  }
  pannelPayoutClick = (count) => {
    // payoutlist1[count].active = true
    // console.log(payoutlist1)
    // const updatedList12 = payoutlist1
    // setpayoutlines(updatedList12); // Update state


    const newLineCount = count + 1;
    this.activelinesCount(newLineCount);
  }
  activelinesCount = (num) => {

    // const updatedList = payoutlist1.map((line, i) => ({
    //   ...line,
    //   active: i < num  // Make `active` true if index is less than num
    // }));
    const updatedList = [...this.state.UpdatedPayoutList]
    updatedList[num - 1].active = !updatedList[num - 1].active
    this.setState({
      UpdatedPayoutList: updatedList
    })
    let NeeCountValue = updatedList.reduce((a, b) => a + Number(b.active), 0)
    this.setState(
      {
        linescount: NeeCountValue,
        anteamount: Number(this.chipVal[this.state.count - 1].val) * Number(NeeCountValue),
      })
    console.log(this.state.anteamount)
  }
  setNewActiveLines = (type) => {
    let newLinesArray = [...this.state.UpdatedPayoutList];

    if (type === "INC") {
      let updated = false;
      newLinesArray = newLinesArray.map((ele) => {
        if (!updated && !ele.active) {
          updated = true;
          return { ...ele, active: true };
        }
        return ele;
      });
    } else if (type === "DEC") {
      for (let i = newLinesArray.length - 1; i >= 0; i--) {
        if (newLinesArray[i].active) {
          newLinesArray[i] = { ...newLinesArray[i], active: false };
          break;
        }
      }
    }
    // setpayoutlines(newLinesArray);
    this.setState({
      UpdatedPayoutList: newLinesArray
    })
  };
  menuChange = () => {
    console.log(this.state.menuActive)

    this.setState({
      menuActive: !this.state.menuActive
    })
  }
  ClosePopupIB = () => {
    this.setState({
      ErrorPopup: false
    })
  }

  updateplayerbalnace = () => {
    this.props.gamstateHandle();
    const body2 = {
      CN: "GET_PLAYER_INFO",
      object: {
        gameId: Number(this.props.gameId,),
        playerId: Number(this.props.playerId),

      },
      sessionId: sessionStorage.getItem('sessionId'),
    }
    this.props.network.sendof(body2);
    this.body2 = {};
  }
  handleImageLoad = () => {
    const { assestsLoaderFunction } = this.props;
    assestsLoaderFunction()
  }
  freeSpinActive = (res) => {
    console.log(res)
    this.setState({
      isFreeSpins: true,
      TotalFreeSpinsCount: res.freeSpinsCount,
      FreeSpinsCount: res.playedFreeSpinsCount
    })
  }
  freeASpinsStart = () => {
    this.spinaction()
  }
  FreeSpinsClosepopup(showStatus) {
    alert(showStatus)
    this.setState({
      freeSpinsPopup: false
    })
  }

  render() {
    const { count } = this.state;
    const chip = this.chipVal[count - 1]; // index starts from 0
    const isMin = count === 1;
    const isMax = count === this.chipVal.length;

    const iscountmin = this.state.linescount === 1;
    const iscountmax = this.state.linescount === 25;

    return (
      <div className="MainDivSlotBGRT">
        {/* <h1 className="headR">Retro Tech</h1> */}
        <div className="logotittle">
          <img src={logo} alt="" />
        </div>
        <button className="menu_RTDiv" onClick={() => { this.menuChange() }}>
          <img src={menu} alt="" className="menu_RT" />
        </button>
        <div>
          {
            this.state.gamewins ?
              <WinningAmount targetAmount={this.state.winAMT}
                setWinsAndAmount={this.setWinsAndAmount}
              /> : ""
          }
        </div>
        <div>
          {
            this.state.drawnLinesT ?
              <WinLines Winsdata={this.state.drawnLinesresDate}
              /> : ""
          }
        </div>
        <div>
          {
            this.state.WinPulseRT && (
              <WinPulse Winsdata={this.state.drawnLinesresDate} IndexWinsIcons={this.state.IndexWinningIcons}
              />)
          }
        </div>
        <div>
          {
            this.state.WinBGColorsRT && (
              <WinBGColor Winsdata={this.state.drawnLinesresDate} IndexWinsIcons={this.state.IndexWinningIcons}
              />)
          }
        </div>
        <div >
          {
            this.state.freeSpinsPopup && (
              <FreeSpins show={this.state.freeSpinsPopup} FreeSpinsClosepopup={this.FreeSpinsClosepopup}
              />)
          }
        </div>

        <div className="Payout_main_Div">
          <div className='dis_por_top'>
            {this.state.UpdatedPayoutList.slice(0, 12).map((line, i) => (
              <button className='payOutLineBtnRT' style={{ display: "block" }} key={i}
                onClick={() => this.pannelPayoutClick(i)} disabled={this.state.isSpinning}
              >
                <h1
                  className={`payoutboxSRT1 ${line.active ? 'linesCount_BGRT' : ''}`}>
                  {line.linesCount}
                </h1>
              </button>
            ))}
          </div>
          <div className="SlotsEngineMain">
            <Slotsanimation
              ref={this.Slotsanimation}
              gameId={this.props.gameId}
              playerId={this.props.playerId}
              handId={this.props.gameState.handId}
              balance={this.props.balance}
              betamount={this.state.anteamount}
              chipcount={this.state.chipcount}
              autoPlayCount={this.state.autoPlayCount}
              setAutoPlayCount={(num) => {
                this.setState({ autoPlayCount: num })
              }}
              setWinsAndAmount={this.setWinsAndAmount}
              getGameState={this.getGameState}
              updateplayerbalnace={this.updateplayerbalnace}
              createLineMain={this.CreateRetroLines}
              CreateWinAnimateLines={this.CreateWinAnimationsData}
              SetSpinDisable={this.SpinControlDis}
              GameType={"Retro"}
              Reels={5}
            />
          </div>
          <div className='dis_por_bottom'>
            {
              this.state.UpdatedPayoutList.slice(12, 25).map((lines, i) => {
                return (
                  <button className='payOutLineBtnRT' key={i} style={{ display: "block" }} onClick={() => this.pannelPayoutClick(i + 12)} disabled={this.state.isSpinning}>
                    <h1 className={`payoutboxSRT2 ${lines.active ? "linesCount_BGRT" : ''}`}>
                      {lines.linesCount}</h1>
                    {/* <div className='payoutLineImage'>
                  {Array.from({ length: 3 }, () =>
                    Array.from({ length: 5 }, () => 0)
                  ).map((ele, row) => <div className='payLineRow' key={row}>{ele.map((_, col) => <div key={col} className='payLineColumn' style={lines.payoutLine[col] === row ? { "backgroundColor": lines.clr } : {}}></div>)}</div>)}
                </div> */}
                  </button>
                )
              })
            }
          </div>
        </div>
        <div className="main_disply_center topsectopnMBmode">
          <div className="balancewinsection">
            <div className="balance_winDiv">
              <div className="text-center MainBalanceSn">
                <p className="amt_num transfr_down">{this.state.TotalBalance}</p>
                <img src={balance} alt="" className="imgbtn upsection" />
              </div>
              <div className="text-center">
                <p className="amt_num transfr_down">0</p>
                <img src={win} alt="" className="imgbtn up section" />
              </div>
            </div>
          </div>
        </div>
        <div className="balancewinsection btm_position">
          <div className="main_disply_center">
            <div className="clearbetbtn">
              {/* <img src={clear} alt="" className="imgbtn" /> */}
              <div className="betamvalue">
                <p className="amt_num tns_position_betRT">{this.state.anteamount}</p>
                <img src={bet} alt="" className="imgbtn" />
              </div>
              {/* <div> */}
              <div className="mainchipdiv_linescount">
                <img src={linescountimg} alt="" className="" />
                <div className="RT_linesCountDiv">

                  <button
                    disabled={iscountmin || this.state.isSpinning}
                    className={`${iscountmin ? "icon_opacity" : ""}`}
                    onClick={this.Decreamentlinescount}
                  >
                    <h1 className=" amt_num">-</h1>
                  </button>
                  <p className="amt_num m_t_15" style={{ marginTop: "15px", cursor: "pointer" }} onClick={this.OpenPayoutTable}>
                    {this.state.linescount}
                  </p>
                  <button
                    disabled={iscountmax || this.state.isSpinning}
                    className={`${iscountmax ? "icon_opacity" : ""}`}
                    onClick={this.Increamentlinescount}
                  >
                    <h1 className=" amt_num" >+</h1>
                  </button>

                </div>

              </div>
              {/* </div> */}
            </div>


            <div className="mainchipdiv">
              <button
                disabled={isMin || this.state.isSpinning}
                className={`${isMin ? "icon_opacity" : ""}`}
                onClick={this.DecreamentBetchips}
              >
                <img src={betincerementdecrement} alt="Decrease Chip" />
              </button>

              <div className="chip-display">
                {/* <img src={chip.src} alt={`Chip ${chip.label}`} className="chip-image" />
                <div className="chip-label">{chip.label}</div> */}
                <div className="retro-chips" style={{ "--selectedIndex": count - 1 }}>
                  <Chips gameChips={this.props.os_chipValues} selectedChipIndex={count - 1}></Chips>
                </div>
                <img src={circlechip} alt="chipcircle" className="chipcirclecs" />
              </div>
              <button
                disabled={isMax || this.state.isSpinning}
                className={`decreaechipbtn  ${isMax ? "icon_opacity" : ""}`}
                onClick={this.IncreamentBetchips}
              >
                <img src={betincerementdecrement} alt="Increase Chip" />
              </button>
            </div>


            <div className="mainbtn12">
              {/* <img src={freespins} alt="" className="imgbtn" /> */}
              <button id="autoPlayBtnRT" disabled={this.state.isSpinning}>
                <p className="amt_num">FREE SPIN</p>
              </button>
              <button id="autoPlayBtnRT" className={`${this.state.isAutoPlay ? "autoPlayActive" : ""}`} onClick={this.handleAutoPlayClick} disabled={!this.state.isAutoPlay && this.state.isSpinning}>
                <p className="amt_num">AUTO {this.state.autoPlayCount ? ": " + this.state.autoPlayCount : "PLAY"}</p>
              </button>
              {/* <img onClick={() => { this.setState((prevState) => ({ ...prevState, showAutoPlayOptions: !prevState.showAutoPlayOptions })) }} src={autoplay} alt="" className="imgbtn" /> */}

              <button className="Spinbtnretro" onClick={this.spinaction} disabled={this.state.isSpinning}>
                <img src={spinbtn} alt="Spin" className="imgbtnspin imgbtn" />
              </button>
            </div>


          </div>
        </div>
        {this.state.PayoutTableShow &&
          <div className="">
            <div onClick={this.ClosePayoutTable} className="autoOptionsCoverBack" style={{ cursor: "pointer" }} ></div>
            <div className="paylines-overlay payoutTableMainDiv">
              <div className="paylines-box">
                <h2 className="title">LINES</h2>
                <p className="line_changes"></p>
                <div className="paylines-grid">
                  {this.paylines.map((line) => {
                    const points = line.positions
                      .map((row, col) => {
                        const x = col * this.cellSize + this.cellSize / 2;
                        const y = row * this.cellSize + this.cellSize / 2;
                        return `${x},${y}`;
                      })
                      .join(" ");

                    return (
                      <div key={line.id} className="line-box">
                        <div className="line-num">{line.id}</div>
                        <svg
                          width={this.cellSize * this.cols}
                          height={this.cellSize * this.rows}
                          className="payline-svg"
                        >
                          {/* Draw background grid */}
                          {[...Array(this.rows)].map((_, r) =>
                            [...Array(this.cols)].map((_, c) => {
                              const isHighlighted = line.positions[c] === r;
                              return (
                                <rect
                                  key={`${r}-${c}`}
                                  x={c * this.cellSize}
                                  y={r * this.cellSize}
                                  width={this.cellSize}
                                  height={this.cellSize}
                                  fill={isHighlighted ? this.activeColor : this.inactiveColor}
                                  stroke="#333"
                                  strokeWidth="1"
                                />
                              );
                            })
                          )}

                          {/* Draw line through selected cells */}
                          <polyline
                            points={points}
                            fill="none"
                            stroke={this.lineColor}
                            strokeWidth="4"  // 🔹 bold like Hawaiian Waves
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />

                          {/* Draw dots on path */}
                          {line.positions.map((row, col) => (
                            <circle
                              key={col}
                              cx={col * this.cellSize + this.cellSize / 2}
                              cy={row * this.cellSize + this.cellSize / 2}
                              r="2"
                              fill="#470461c7"
                              stroke={this.lineColor}
                              strokeWidth="1"
                            />
                          ))}
                        </svg>
                      </div>
                    );
                  })}
                </div>

              </div>
            </div>
          </div>
        }


        {this.state.showAutoPlayOptions && <div className="autoOptionsCoverBack"><div className="autoPlayOptions">
          <h1 className="amt_num">Auto Play</h1>
          <button onClick={() => { this.setState({ showAutoPlayOptions: false, autoPlayCount: 0 }) }} className="autoPlayCloseBtn" style={{ background: `url(${closeBtn})`, height: "61px", width: "61px" }}></button>
          {/* <img onClick={() => { this.setState({ showAutoPlayOptions: false }) }} src={closeBtn} className="autoPlayCloseBtn" /> */}
          <div className="displayAutoOptions">
            {this.state.autoPlayOptions.map((ele, ind) =>
              <button
                className={`autoPlayNumbersRT${ele === this.state.autoPlayCount ? " selectedAutoPlayOption" : ""}`}
                disabled={ele === this.state.autoPlayCount}
                onClick={() => { this.setState({ autoPlayCount: ele }) }} key={ind}>
                <p>{ele}</p>
              </button>)}
          </div>
          <div className="displayAutoOptions">
            <button className="autoPlayNumbersRT cancelBtn" disabled={!this.state.autoPlayCount} onClick={() => { this.setState({ autoPlayCount: 0 }) }}><p>CLEAR</p></button>
            <button className="autoPlayNumbersRT playBtn" disabled={!this.state.autoPlayCount} onClick={this.handleAutoPlayClick}><p>PLAY</p></button>
          </div>
        </div>
        </div>}

        {this.state.showCancelAutoPlay && <div className="autoOptionsCoverBack">
          <div className="autoPlayOptions">
            <h1 className="amt_num">Are You Sure To Stop Auto Play?</h1>
            <div className="displayAutoOptions">
              <button
                className={`autoPlayNumbersRT`}
                onClick={this.stopAutoPlay}>
                <p>YES</p>
              </button>
              <button
                className={`autoPlayNumbersRT`}
                onClick={this.restartAutoPlay}>
                <p>NO</p>
              </button>
            </div>
          </div>
        </div>}
        {
          this.state.menuActive &&
          <div className="MenuMainDiv">
            <ul>
              <li>Limits</li>
              <li>Help</li>
              <li>History</li>
            </ul>
          </div>
        }
        {
          this.state.ErrorPopup && <div class="frame">
            <div class="modal">
              <div>
                <img src="https://100dayscss.com/codepen/alert.png" width="44" height="38" />
                <span class="title">insufficient balance!</span>
                <p>You have insufficient balance for the bet.</p>
                <div onClick={() => {
                  this.ClosePopupIB()
                }}
                  class="button">X</div>
              </div>
            </div>
          </div>

        }
      </div>

    );
  }
}

export default RetroTech

